<template>
	<div v-show="false">
		<select
			v-show="configStore.languages?.length > 0"
			v-model="configStore.selectedLanguage"
			id="language"
			class="w-full p-2 border-2 cursor-pointer rounded-md focus:border-black focus:ring focus:outline-none"
		>
			<option value="" selected disabled hidden>Výber jazyka</option>
			<option
				v-for="language in configStore.languages"
				:key="language.id"
				:value="language.id"
			>
				{{ language.name }}
			</option>
		</select>
	</div>
</template>

<script setup>
import useConfigStore from '~/store/config'

const configStore = useConfigStore()
</script>
